




















import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import SimpleTable from "@/basics/table/SimpleTable.vue";
import NoData from "@/basics/boxes/NoData.vue";
import {
  GROUP_ONE,
  GroupVariables,
  GroupOneData
} from "@/graphql/query/group/one";
import { toString } from "@/lib/scope";
import { ScopeData } from "@/graphql/scopeData";

export interface User {
  id: string;
  name: string;
  email: string;
  scopes: ScopeData[];
  role: string;
}

@Component({
  components: {
    CButton,
    SimpleTable,
    NoData
  },
  apollo: {
    users: {
      query: GROUP_ONE,
      variables(): GroupVariables {
        return { id: this.$apollo.vm.$route.params.groupId };
      },
      update(data: GroupOneData): User[] {
        return data.group.users.map(u => ({
          ...u,
          role: toString(u.scopes, data.group.id)
        }));
      }
    }
  }
})
export default class GroupUsers extends Vue {
  users: User[] = [];
}
